export const commercialBase = {
  id: "commercial",
  name: "Commercial",

  scene: {
    backgroundImage: null,
    baseColor: "#0b0f14",
    radialGlow: "radial-gradient(ellipse at 50% 40%, rgba(78, 161, 255, 0.08) 0%, transparent 65%)",
    overlayTint: "rgba(8, 12, 16, 0.28)",
    vignette: 0.52,
    parallaxStrength: 0.3,
    particleType: "none",
  },

  glass: {
    bg: "rgba(16, 20, 28, 0.55)",
    blur: 14,
    border: "rgba(255, 255, 255, 0.10)",
    radius: 14,
  },

  glow: {
    edgeColor: "rgba(78, 161, 255, 0.35)",
    edgeStrength: 0.35,
    heroBoost: 0.5,
  },

  accent: {
    primary: "#4ea1ff",
    secondary: "#2f6fbf",
  },

  numeric: {
    positive: "#22c55e",
    warning: "#f59e0b",
    danger: "#ef4444",
  },

  ai: {
    orbStyle: "bot",
    orbGlow: "rgba(78,161,255,0.32)",
  },

  tokens: {
    "--tl-bg-0": "#0b0f14",
    "--tl-bg-1": "#0a0d12",
    "--tl-bg-2": "#06080c",
    "--tl-text-0": "#e8eef6",
    "--tl-text-1": "#c9d4e2",
    "--tl-text-muted": "#9aa7b8",
    "--tl-accent-0": "#4ea1ff",
    "--tl-accent-1": "#2f6fbf",
    "--tl-glass-bg": "rgba(16, 20, 28, 0.55)",
    "--tl-glass-border": "rgba(255, 255, 255, 0.10)",
    "--tl-glass-blur": "14px",
    "--tl-glass-shadow": "0 10px 30px rgba(0,0,0,0.45)",
    "--tl-glass-glow-color": "rgba(78,161,255,0.25)",
    "--tl-glow-edge-color": "rgba(78, 161, 255, 0.35)",
    "--tl-glow-edge-strength": "0.35",
    "--tl-glow-hero-boost": "0.5",
    "--tl-radius": "14px",
    "--tl-molten-wordmark-gradient": "none",
  },
};
